







































































import {Vue, Component} from 'vue-property-decorator';
import FilterApartment from '@/components/FilterApartment';
import SearchingPanel from '@/components/SearchingPanel';
import CatalogList from '@/components/CatalogList';
import AdditionalFilters from '@/components/AdditionalFilters';
import Title from '@/components/Title';
import {mapGetters, mapActions} from 'vuex';
import { objectIsEmpty } from '@/utils';
import { objectToQuerystring } from '@/services/api';
import { CatalogQuery } from '@/types';

@Component({
  name: 'Catalog',
  components: {
    AdditionalFilters, CatalogList,
    FilterApartment, SearchingPanel, Title,
  },
  created(): void {
    this.fetchByQuery();
    this.fetchTranslation();
  },
  data() {
    return {
      initEmpty: false,
      activeApartment_views: [],
      activeDesign: [],
      activeOptions: [],
      activeRules: [],
      datePickerActive: false,
      floor: [],
      price: [],
      reloadFilters: true,
      showAdditionalFilters: false,
      page_size: 20,
      ordering: 'price',
      page: 1,
    };
  },
  computed: {
    ...mapGetters('catalog', [
      'titlePage',
      'filtersApartment',
      'catalogListTexts',
      'additionalFilters',
      'catalogList',
    ]),
    ...mapGetters([
      'searchingPanel',
      'actualSearchData',
      'filters',
      'periodPickerData',
    ]),
  },
  methods: {
    ...mapActions('catalog', [
      'sendApartmentData',
      'sendSearchData',
      'getNextPageApartments',
      'fetchTranslation']),
    ...mapActions([
      'toggleFooter',
      'updateActualSearchData',
    ]),
    fetchByQuery() {
      const query: CatalogQuery = {...this.$route.query};
      if (objectIsEmpty(query)) { return; }
      Object.keys(query).forEach((item) => {
        switch (item) {
          case 'start': {
            const start = query[item];
            this.$set(this.actualSearchData, 'start', start);
            this.$store.dispatch('setStartDate', start);
            break;
          }
          case 'rooms': {
            const rooms = (query[item] as string).split(',');
            this.$set(this.actualSearchData, 'rooms', rooms);
            this.$store.dispatch('actualNumbersRooms', rooms);
            break;
          }
          case 'end': {
            const start = this.$dayjs(`${query.start}`).format('YYYY-MM-DD');
            const end = this.$dayjs(`${query.end}`).format('YYYY-MM-DD');
            let monthPeriod = Math.round(this.$dayjs(end).diff(this.$dayjs(start), 'month', true));
            const newEndDate = this.$dayjs(start).add(this.periodPickerData.limits.min, 'month')
              .format('YYYY-MM-DD');
            if (monthPeriod < this.periodPickerData.limits.min) {
              query.end = newEndDate;
              monthPeriod = this.periodPickerData.limits.min;
            } else if (monthPeriod > this.periodPickerData.limits.min) {
              query.end = this.$dayjs(start).add(monthPeriod, 'month').format('YYYY-MM-DD');
            }
            this.$set(this.actualSearchData, 'end', query[item]);
            this.$store.dispatch('setPeriodPickerValue', monthPeriod);
            break;
          }
          case 'design': {
            const array: string[] = [];
            if (query.design) {
              query.design.split(',').forEach((element: string) => {
                array.push(element);
              });
            }
            this.activeDesign = array.map((val) => parseInt(val, 10));
            break;
          }
          case 'max_price': {
            this.price[1] = query.max_price;
            break;
          }
          case 'min_price': {
            this.price[0] = query.min_price;
            break;
          }
          case 'max_floor': {
            this.floor[1] = query.max_floor;
            break;
          }
          case 'min_floor': {
            this.floor[0] = query.min_floor;
            break;
          }
          case 'options': {
            this.activeOptions = query.options
              ?.split(',')
              .map((val) => parseInt(val, 10))
              ?? [];
            break;
          }
          case 'apartment_views': {
            this.activeApartment_views = query.apartment_views
                ?.split(',')
                .map((val) => parseInt(val, 10))
              ?? [];
            break;
          }
          case 'rule_pets_allowed': {
            this.activeRules.push('rule_pets_allowed');
            break;
          }
          case 'rule_smoking_allowed': {
            this.activeRules.push('rule_smoking_allowed');
            break;
          }
          case 'rule_parties_allowed': {
            this.activeRules.push('rule_parties_allowed');
            break;
          }
          case 'page_size': {
            if (query.page_size) {
              this.page_size = parseInt(query.page_size, 10);
            }
            break;
          }
          case 'ordering': {
            if (query.ordering) {
              this.ordering = query.ordering;
            }
            break;
          }
          case 'page': {
            if (query.page) {
              this.page = parseInt(query.page, 10);
            }
            break;
          }
          default: {
            break;
          }
        }
      });
      this.sendAndClosedAdditionalFilters(query);
    },
    async sendToApiSearch(data) {
      const { query } = await this.sendSearchData(data);
      (this as any).initEmpty = true;
      const currentQuery = `?${objectToQuerystring(this.$route.query)}`;
      // pass NavigationDuplicated error when raplace with same routes
      if (query !== currentQuery) {
        this.$router.replace(query);
      }
    },
    toggleDatePicker() {
      this.datePickerActive = !this.datePickerActive;
    },
    getApartmentsPage(data) {
      const newQuery = {...this.actualSearchData, ...data};
      this.getNextPageApartments(newQuery);
    },
    handleFilter(data) {
      if (!data.page) {
        this.page = 1;
        data.page = this.page;
      } else {
        this.page = parseInt(data.page, 10);
      }
      const newQuery = {...this.actualSearchData, ...data};
      this.updateActualSearchData(newQuery);
      this.sendToApiSearch(newQuery);
    },
    sendAndClosedAdditionalFilters(data) {
      this.handleFilter(data);
      this.closedAdditionalFilters();
    },
    openAdditionalFiltersBlock() {
      this.showAdditionalFilters = true;
      const el: HTMLElement | null = document.querySelector('.additionalFilters-component__mob');
      if (!!el) {
        window.scroll({top: 0, behavior: 'smooth'});
      }
      this.toggleFooter('hide');
    },
    closedAdditionalFilters() {
      this.toggleFooter('show');
      this.showAdditionalFilters = false;
    },
    clearAllFilters() {
      const query = {
        start: this.actualSearchData.start,
        end: this.actualSearchData.end,
        rooms: this.actualSearchData.rooms,
      };
      this.page = 1;
      this.floor = [];
      this.price = [];
      this.clearAdditionalFilters();
      this.updateActualSearchData(query);
      this.sendToApiSearch(query);
      this.reloadFilters = false;
      this.$nextTick(() => {
        this.reloadFilters = true;
      });
    },
    clearAdditionalFilters() {
      this.activeApartment_views = [];
      this.activeDesign = [];
      this.activeOptions = [];
      this.activeRules = [];
    },
  },
})
export default class Catalog extends Vue {}
